if (!customElements.get('onyra-jewellery-guide')) {
  class OnyraJewelleryGuide extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.opener = this.closest('kit-variant-picker')?.querySelector('[data-onyra-guide-target="' + CSS.escape(this.dialog?.id ?? '') + '"]');
      if (!this.dialog || !this.opener) return;
      this.opener.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.dialog.querySelector('h2').focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-onyra-guide-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        if (this.opener.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow ?? '';
      }
      this.controller?.abort();
    }
  }
  customElements.define('onyra-jewellery-guide', OnyraJewelleryGuide);
}

